module.exports = __webpack_public_path__ + "img/foto2.0ae01d91.jpg";